import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failureGetLibraryFiles,
    successGetStudyMaterials,
    successGetWorksheets,
} from "./LibraryFilesSlice";

// API call to fetch worksheets
const GetLibraryWorksheetsApi = (scheduled_class_id: string) => {
    return api.get(`/api/library/worksheets/${scheduled_class_id}`);
};

// API call to fetch study materials
const GetLibraryStudyMaterialsApi = (scheduled_class_id: string) => {
    return api.get(`/api/library/study-materials/${scheduled_class_id}`);
};

// Saga for Library Worksheets
export function* LibraryWorksheetsCall(action: PayloadAction<string>) {
    try {
        const response: AxiosResponse = yield call(GetLibraryWorksheetsApi, action.payload);
        yield put(successGetWorksheets(Array.isArray(response.data?.data) ? response.data.data : Array.isArray(response.data) ? response.data : []));
    } catch (error: any) {
        yield put(failureGetLibraryFiles(error.response?.data || error.message));
    }
}

// Saga for Library Study Materials
export function* LibraryStudyMaterialsCall(action: PayloadAction<string>) {
    try {
        const response: AxiosResponse = yield call(GetLibraryStudyMaterialsApi, action.payload);
        yield put(successGetStudyMaterials(Array.isArray(response.data?.data) ? response.data.data : Array.isArray(response.data) ? response.data : []));
    } catch (error: any) {
        yield put(failureGetLibraryFiles(error.response?.data || error.message));
    }
}
